import React, { Component } from "react";
import check from "../assets/images/check.svg";
import students from "../assets/images/students.png";
import teacher from "../assets/images/teacher.png";
import parents from "../assets/images/parents.png";

class Support extends Component {
  render() {
    return (
      <>
        <div id="support" className="container section-container">
          <div className="pb-5 px-5">
            <h1 className="edsider-section-title support-title">
              We are here to support
            </h1>
          </div>
          <div className="row">
            {/* <!-- Left Column --> */}
            <div className="col-md-5 support-left-col d-flex justify-content-center align-items-center">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-center">
                  <img src={students} className="support-img" alt="student" />
                </div>
                <div className="d-flex justify-content-center col-md-12 d-flex align-items-center text-container">
                  <p>Students</p>
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="parents-wrapper">
                  {/* <p className="coming-soon-text">Coming Soon...</p> */}
                  <div className="col-md-12 d-flex justify-content-center">
                    <img src={parents} className="support-img" alt="student" />
                  </div>
                </div>
                <div className="d-flex justify-content-center col-md-12 d-flex align-items-center text-container">
                  <p>Parents</p>
                </div>
              </div>
            </div>

            {/* <!-- Right Column --> */}
            {/* <div className="col-md-6 hero-container border border-danger">1</div> */}
            <div className="col-md-6 hero-container">
              <div className=" row d-flex justify-content-between">
                <div className="col-md-12 support-container d-flex align-items-center">
                  <div className="row support-card">
                    <div className="col-md-2 check-container d-flex align-items-center support-check">
                      <img src={check} alt="check-icon" />
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-12 support-row-title pb-3">
                          Online MCQs
                        </div>
                        <div className="col-md-12 support-row-content">
                          Take model papers online and get immediate results
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 support-container d-flex align-items-center">
                  <div className="row support-card">
                    <div className="col-md-2 check-container d-flex align-items-center support-check">
                      <img src={check} alt="check-icon" />
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-12 support-row-title pb-3">
                          Comprehensive Coverage
                        </div>
                        <div className="col-md-12 support-row-content">
                          <p className="support-row-content">
                            &#8226; Content Coverage <br />
                            {/* &#8226; Different difficulty levels <br /> */}
                            &#8226; Practice Timing
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 support-container d-flex align-items-center">
                  <div className="row support-card">
                    <div className="col-md-2 check-container d-flex align-items-center support-check">
                      <img src={check} alt="check-icon" />
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-12 support-row-title pb-3">
                          Prepared by Experienced Teachers
                        </div>
                        <div className="col-md-12 support-row-content">
                          High-quality educational materials developed by
                          subject specialists
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Support;
